import { JSX, useCallback } from "react";
import { useTranslation } from "react-i18next";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import RatingSettings from "core/blueprint/trajectory/RatingSettings";
import { RatingField } from "core/field/FieldService";

import { ChangeEvent, Event } from "utils/history/Event";

import FieldBaseRow, { FieldRowProps } from "./FieldBaseRow";

export type RatingFieldRowProps = FieldRowProps & {
	field: RatingField;
};

function RatingFieldRow(props: RatingFieldRowProps): JSX.Element {
	const { t } = useTranslation();

	const onChangeInfo = useCallback(
		(event: Event): void => {
			event.applyContext("/info");
			props.onChange(event);
		},
		[props.onChange]
	);

	const onChangeOverride = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			props.onChange(
				new ChangeEvent(
					"/override",
					props.field.override,
					event.target.checked
				)
			);
		},
		[props.onChange, props.field.override]
	);

	return (
		<FieldBaseRow {...props}>
			{/* TODO: allow default value. */}
			<FormControlLabel
				control={
					<Checkbox
						checked={props.field.override}
						disabled={!props.editable}
						onChange={onChangeOverride}
					/>
				}
				label={t("overrideTrajectoryDefault")}
			/>
			{props.field.override && (
				<RatingSettings
					scoreInfo={props.field.info}
					disabled={!props.editable}
					onChange={onChangeInfo}
				/>
			)}
		</FieldBaseRow>
	);
}

export default RatingFieldRow;
